import { render, staticRenderFns } from "./LawNormViewTable.vue?vue&type=template&id=fc2b7a02"
import script from "./LawNormViewTable.vue?vue&type=script&lang=js"
export * from "./LawNormViewTable.vue?vue&type=script&lang=js"
import style0 from "./LawNormViewTable.vue?vue&type=style&index=0&id=fc2b7a02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports